import { PopupReturnTypeWithPayload } from '../../../../hooks/usePopup'
import { initialPopup } from '../../../../hooks/constants'
import { ILedByGPOTable } from '../../../../redux/store/adminSplitFees/types'
import { LedByCommunityGroup } from '../../AdminSplitFees/Community/LedByCommunityTable/types'

export const editLedByGPOPopupWithPayload: PopupReturnTypeWithPayload<{
  selectedRow: ILedByGPOTable
}> = {
  state: {
    ...initialPopup?.state,
    payload: {
      selectedRow: {} as ILedByGPOTable
    }
  },
  actions: {
    ...initialPopup.actions,
    setState: () => undefined
  }
}

export const editLedByCommunityPopupWithPayload: PopupReturnTypeWithPayload<{
  selectedRows: LedByCommunityGroup[]
}> = {
  state: {
    ...initialPopup?.state,
    payload: {
      selectedRows: [] as LedByCommunityGroup[]
    }
  },
  actions: {
    ...initialPopup.actions,
    setState: () => undefined
  }
}
